import classNames from "classnames";
import type { DetailedHTMLProps, InputHTMLAttributes } from "react";
import React, { forwardRef, useEffect, useRef } from "react";
import styles from "./Input.module.scss";
import { useFormContext } from "react-hook-form";

interface InputError {
  message?: string;
}

type InputProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  error?: InputError;
  label: string;
};

const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const {
    onBlur,
    type = "text",
    error,
    label,
    name,
    autoComplete,
    onChange,
  } = props;
  const { setValue } = useFormContext();

  const reference = useRef<HTMLInputElement | null>(null);

  function handleSetRef(_ref: HTMLInputElement) {
    if (typeof ref === "function") {
      ref(_ref);
    }
    reference.current = _ref;
  }

  /**
   * @description this logic needs for setting up
   * the value back after you are returning back
   * through the history route
   */
  useEffect(() => {
    if (reference.current) {
      if (reference.current.value && name !== undefined && name !== "") {
        setValue(name, reference.current.value);
      }
    }
  }, [reference, name, setValue]);

  return (
    <label className={styles.label}>
      <p className={styles.inputText}>{label}</p>
      <input
        className={classNames(styles.input, {
          [String(styles.invalidInput)]: error,
        })}
        type={type}
        ref={handleSetRef}
        name={name}
        autoComplete={autoComplete}
        onBlur={onBlur}
        /**
         * @description onChange needs to auto populating
         * field in the form. Without it form don't works
         * correctly
         */
        onChange={onChange}
      />

      {error !== undefined && error.message !== "" && (
        <strong className={classNames(styles.error, styles.inputText)}>
          {error.message}
        </strong>
      )}
    </label>
  );
});

Input.displayName = "Input";
export { Input };
